import React from 'react';

import NoteDisplay from '../NoteDisplay';
import MetaToggleDisplay from '../MetaToggleDisplay';

export const FIELDS = [
  {
    id: 'userEmail',
    title: 'Cancelled by',
    render: (email, { UserId }) =>
      email ? `User #${UserId} (${email})` : 'Not specified',
  },
  {
    id: 'id',
    title: 'Cancellation meta',
    render: () => <MetaToggleDisplay />,
  },
  {
    id: 'notes',
    title: 'Cancellation note',
    render: note => <NoteDisplay content={note} />,
  },
];
